import axios from 'axios'
import path from 'path'
import { getLocale } from '../helpers/api'
import { RMSRequestUrl } from '../helpers/requests'

const RMS_API = process.env.RMS_API_URL || ''
const RMS_PUBLIC_API_TOKEN = process.env.RMS_PUBLIC_API_TOKEN || ''

export type ContactRequestType = 'CANCELLATION' | 'RETURN'

export interface CreateContactRequestDto {
  orderReference: string
  email: string
  type: ContactRequestType
  message?: string
}

export interface ContactRequestResponse {
  id: number
  order_reference: string
  email: string
  type: ContactRequestType
  message?: string
  locale: string
  created_at: string
}

/**
 * The contact-requests endpoint expects a locale like "fr-fr", whereas
 * `getLocale()` returns the Sylius format ("fr_FR"). Normalise it here.
 */
export const toContactRequestLocale = (customLocale?: string): string =>
  getLocale(customLocale).replace('_', '-').toLowerCase()

const contactRequestsUrl = (): string => {
  const baseUrl = RMS_API.endsWith('/api') ? `${RMS_API}/` : `${RMS_API}/api/`
  return `${baseUrl}${path.join(RMSRequestUrl.contactRequests, '')}`
}

/**
 * Creates a public "retraction / cancellation" contact request on the RMS.
 * Identified by the store's public app token (x-api-key), so no login needed.
 */
export const createContactRequest = (
  payload: CreateContactRequestDto
): Promise<ContactRequestResponse> =>
  axios({
    method: 'POST',
    url: contactRequestsUrl(),
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': RMS_PUBLIC_API_TOKEN,
    },
    data: {
      orderReference: payload.orderReference,
      email: payload.email,
      type: payload.type,
      ...(payload.message ? { message: payload.message } : {}),
      locale: toContactRequestLocale(),
    },
  }).then((res) => res.data)
